var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSymbolsClose(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon/Bold/Close"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/bold/Close"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon/bold/Close/24/Black",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.271234 17.7283C0.451378 17.9098 0.688482 18 0.925586 18C1.16246 18 1.39957 17.9087 1.58107 17.7283L9.00013 10.3092L16.4198 17.7283C16.6002 17.9098 16.8371 18 17.0742 18C17.3099 18 17.5468 17.9087 17.7283 17.7283C18.0899 17.3667 18.0899 16.7804 17.7283 16.4187L10.3095 8.99984L17.7283 1.58107C18.0899 1.2192 18.0899 0.63288 17.7283 0.271234C17.3667 -0.0904114 16.7803 -0.0904114 16.4187 0.271234L8.99983 7.6901L1.58107 0.271234C1.2192 -0.0904114 0.632879 -0.0904114 0.271234 0.271234C-0.0904113 0.63288 -0.0904113 1.2192 0.271234 1.58107L7.69036 8.99957L0.271234 16.4187C-0.0904113 16.7803 -0.0904113 17.3667 0.271234 17.7283Z",
    fill: "black"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolsClose);
export default __webpack_public_path__ + "static/media/symbols_close.780c9605d883e84016250c73a209095b.svg";
export { ForwardRef as ReactComponent };